<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <div class="main-wrapper">
      <layout-header @changedLanguage="changedLanguage"></layout-header>
      <layout-navbar></layout-navbar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

          <div class="crms-title row bg-white">
            <div class="col  p-0">
              <h3 class="page-title m-0">
                        <span class="page-title-icon bg-gradient-primary text-white mr-2">
                          <i class="feather-grid"></i>
                        </span> {{ $t('menu.incidents') }} </h3>
            </div>
            <div class="col p-0 text-right">
              <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
                <li class="breadcrumb-item"><router-link to="/index">DSMS</router-link></li>
                <li class="breadcrumb-item active">{{ $t('menu.incidents') }}</li>
              </ul>
            </div>
          </div>

          <!-- Page Header -->
          <div class="page-header pt-3 mb-0 ">
            <div class="row">
              <div class="col-12 text-right">
                <ul class="list-inline-item pl-0">
                  <li class="list-inline-item">
                    <DisplayColumnsComponent :table="table" :columns="columns" v-if="table"></DisplayColumnsComponent>
                  </li>
                  <li class="list-inline-item">
                    <button class="add btn btn-gradient-primary font-weight-bold text-white todo-list-add-btn btn-rounded" @click.prevent="showIncident(null)">{{ $t('new_entry') }}</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Content Starts -->
          <DataTableDSMS
            ref="dataTableDSMS"
            title="Incident"
            fileName="Dienstleister"
            modelName="incident"
            deleteURL="todos/v1/delete_incident/"
            :editorPatchURL="editorPatchURL"
            :columns="columns"
            :objects="incidentsList"
            :exportColumns="[0, 1]"
            @tableCreated="setTable"
            @editorCreated="setEditor"
            @showObject="showIncident"
            v-if="promiseFinished"
          ></DataTableDSMS>

          <FingerPrintSpinner v-show="!promiseFinished" color="#9b3136" :size="300" :container-padding="100" />
          <!-- /Content End -->

        </div>
        <!-- /Page Content -->

      </div>
      <!-- /Page Wrapper -->

    <!--modal section starts here-->
      <Task :currentTodo="currentTodo" origin="incident" @todoUpdated="updateTodo">
        <template v-slot:steps>
          <Steps
            :totalSteps="currentTodo.steps"
            :taskID="currentTodo.id"
            @stepsUpdated="setSteps"
          ></Steps>
        </template>
      </Task>

      <IncidentComponent :incident="currentIncident" @incidentUpdated="setIncident" >
        <template v-slot:fileUpload><file-upload :commentObject="currentIncident" modelName="incident" @attachmentUpdated="setIncident" modelVerboseName="Incident"></file-upload></template>
      </IncidentComponent>
    </div>
  </div>
</template>
<script>
  import service from '@/utils/request.js';
  import {mapGetters, mapState} from 'vuex';
  import { useVuelidate } from '@vuelidate/core';
  import { required } from '@vuelidate/validators';
  import { deepCopy, boolDisplay } from '@/utils/index.js';
  import {newTodo, newIncident, objectModalName} from "@/utils/enums";
  import DKLVendor from '@/components/component/VendorComponent'
  import CommentComponent from '@/components/component/CommentComponent'
  import FileUploadComponent from "@/components/component/FileUploadComponent";
  import DataTableDSMS from "@/components/component/DataTableDSMS.vue";
  import comments from "@/components/component/CommentComponent.vue";
  import system from "@/components/component/SystemComponent.vue";
  import DisplayColumnsComponent from "@/components/component/DisplayColumnsComponent.vue";
  import IncidentComponent from "@/components/component/IncidentComponent.vue";
  import Task from "@/components/component/TodoComponent.vue";
  import Steps from "@/components/component/Steps.vue";
  import FingerPrintSpinner from "@/components/component/FingerPrintSpinner.vue";

  export default {
    components: {
      FingerPrintSpinner,
      'file-upload': FileUploadComponent,
      Steps, Task,
      DisplayColumnsComponent,
      system, comments,
      DataTableDSMS,
      DKLVendor,
      CommentComponent,
      IncidentComponent,
    },
    data() {
      return {
        incidentsList: [],
        currentIncident: {},
        currentTodo: {},
        taskReturnIncident: false,
        editorPatchURL: '/todos/v1/patch_incident/',
        table: null,
        editor: null,
        promiseFinished: false,
      }
    },
    created() {
      this.getIncidents()
    },
    validations() {
      return {
        current_supplier: {
          name: {required, $lazy: true},
          contract: {required, $lazy: true},
          responsible_department: {required, $lazy: true},
        },
      }
    },
    setup() {
      return {
        v$: useVuelidate()
      }
    },
    computed: {
      ...mapState({
        accountid: state => state.account.accountid,
        user: state => state.user,
        account: state => state.account,
        departments: state => state.account.departments,
        dataTypes: state => state.account.dataTypes,
        systems: state => state.account.systems
      }),
      ...mapGetters(['selectDepartmentOptions', 'selectDataTypeOptions', 'selectSystemOptions']),

      columns() {
        return [
          {
            label: 'Nr.#',
            name: 'sequence',
            enableEditor: false,
            definition: {data: "sequence", width: '50px', className: 'dkl-vt-sequence reorder'},
          },
          {
            label: this.$t('creation_date'),
            name: 'added',
            enableEditor: false,
            definition: { data: "added", render: (data, type, row) => data.substring(0, 10)},
          },
          {
            label: this.$t('incident_acknowledgement'),
            name: 'datetime',
            type: 'datetime',
            format: 'YYYY-MM-DD, h:mm',
            enableEditor: true,
            definition: { data: "datetime" },
          },
          {
            label: this.$t('reporting_party'),
            name: 'reporter',
            type: 'text',
            className: 'dkl-font-13',
            enableEditor: true,
            definition: { data: "reporter" },
          },
          {
            label: this.$t('incident_description'),
            name: 'description',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 8
            },
            enableEditor: true,
            definition: { data: "description" },
          },
          {
            label: this.$t('incident_consequences'),
            name: 'consequence',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 8
            },
            enableEditor: true,
            definition: { data: "consequence"},
          },
          {
            label: this.$t('authority_notification'),
            name: 'inform_lda',
            type: 'radio',
            options: [
              {label: this.$t('authority_notified'), value: true},
              {label: this.$t('not_authority_notified'), value: false}
            ],
            enableEditor: true,
            definition: { data: "inform_lda", render: (data, type, row) => `${boolDisplay[data]}`, editField: ['inform_lda', 'date_inform_lda'] },
          },
          {
            label: this.$t('notification_date'),
            name: 'date_inform_lda',
            type: 'datetime',
            enableEditor: true,
            definition: { data: "date_inform_lda" },
          },
          {
            label: this.$t('data_subject_information'),
            name: 'inform_affected',
            type: 'radio',
            options: [
              {label: this.$t('data_subject_informed'), value: true},
              {label: this.$t('data_subject_not_informed'), value: false}
            ],
            enableEditor: true,
            definition: { data: "inform_affected", render: (data, type, row) => `${boolDisplay[data]}`, editField: ['inform_affected', 'inform_affected_remarks'] },
          },
          {
            label: this.$t('data_subject_informed_how'),
            name: 'inform_affected_remarks',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 8
            },
            enableEditor: true,
            definition: { data: "inform_affected_remarks" },
          },
          {
            label: this.$t('incident_action_plan'),
            name: 'followups',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 8
            },
            enableEditor: true,
            definition: { data: "followups" },
          },
          {
            label: this.$t('process_controller'),
            name: 'responsible',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 8
            },
            enableEditor: true,
            definition: { data: "responsible" },
          },
          {
            label: this.$t('comments'),
            name: 'remarks',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 8
            },
            enableEditor: true,
            definition: { data: "remarks" },
          },
        ]
      },
    },
    mounted() {
    },
    updated ()
    {

      // Date Time Picker

      if ($('.datetimepicker').length > 0) {
        $('.datetimepicker').datetimepicker({
          format: 'DD/MM/YYYY',
          icons: {
            up: "fa fa-angle-up",
            down: "fa fa-angle-down",
            next: 'fa fa-angle-right',
            previous: 'fa fa-angle-left'
          }
        });
      }
    },
    methods: {
      async changedLanguage() {
        this.$nextTick(async () => {
          if (this.table) this.table.destroy();
          await this.$refs.dataTableDSMS.initTable();
        });
      },
      setTable(table) {
        this.table = table
      },
      setEditor(editor) {
        this.editor = editor
      },
      setSteps(steps) {
        this.currentTodo.steps = steps
      },
      async setIncident(incidentObject) {
        const incidentIndex = this.incidentsList.findIndex(item => item.id === incidentObject.id)
        if (incidentIndex === -1) {
          this.incidentsList = this.incidentsList.map(item => {
            item.sequence = item.sequence + 1
            return item
          })
          this.incidentsList.push(incidentIndex)
        } else {
          this.incidentsList[incidentIndex] = incidentObject
        }
        this.table.clear().rows.add(this.incidentsList).draw(false)
      },
      openTask() {
        $('#' + objectModalName.incident).modal('hide')
        this.currentTodo = deepCopy(newTodo)
        this.currentTodo.model = 'incident'
        this.currentTodo.origin = 'incident'
        this.currentTodo.object_id = this.currentIncident.id
        this.setEdit(true)
        this.taskReturnIncident = true
        $('#' + objectModalName.task).modal('show')
      },
      updateTodo(todoObject) {
        const todoIndex = this.currentIncident.tasks.findIndex(todo => todo.id === todoObject.id)
        if (todoIndex === -1) {
          this.currentIncident.tasks.push(todoObject)
        } else {
          this.currentIncident.tasks[todoIndex] = todoObject
        }
        const incidentIndex = this.incidentsList.findIndex(incident => incident.id === this.currentIncident.id)
        this.incidentsList[incidentIndex] = this.currentIncident
        this.table.clear().rows.add(this.incidentsList).draw()
        $('#' + objectModalName.task).modal('hide')
        this.$vToastify.success('Maßnahme ist erfolgreich gespeichert!')
        if (this.taskReturnIncident) {
          $('#' + objectModalName.incident).modal('show')
        }
        this.taskReturnIncident = false
      },
      showIncident(objectID) {
        if (objectID) {
          this.currentIncident = this.incidentsList.filter(item => item.id == objectID)[0]
        } else {
          this.currentIncident = deepCopy(newIncident)
        }
        $('#' + objectModalName.incident).modal('show')
      },
      toggle_column(event, column_index) {
        // Get the column API object
        let column = $('.datatable').DataTable().column(column_index);

        // Toggle the visibility
        column.visible(!column.visible());

        // adjust dropdown menu
        if (column.visible() && !$(event.target).hasClass('selected')) {
          $(event.target).addClass('selected')
        } else if (!column.visible() && $(event.target).hasClass('selected')) {
          $(event.target).removeClass('selected');
        }
      },
      async getIncidents() {
        service.request({
          url: `todos/v1/incidents/${this.accountid}/`,
          method: 'GET',
          responseType: 'json'
        }).then((response) => {
          this.incidentsList = response.data;
          this.promiseFinished = true
        }).catch(function(err) {
          console.log(err);
          this.promiseFinished = true
        })
      },
    }
  }
</script>
<style>
</style>
